import { FIRST_CBT_NAMESPACE_ID } from 'src/constants';
import {
  BALLOON_MATURITIES,
  CONSTRUCTION_LOAN,
  HOME_EQUITY,
  PERSONALLOANS,
  PURCHASE,
  REFINANCE,
  RESIDENTIAL_MORTGAGE,
  SECURED,
} from 'src/features/LoansHome/Products/constants';
import {
  APPLICANT,
  APPRAISAL_ACCEPTED,
  APPRAISAL_ORDERED,
  APPRAISAL_RECEIVED,
  APPRAISAL_SCHEDULED,
  SMARTMATCH_TYPE_ADMIN,
  STATUS_ADDITIONAL_INFORMATION,
  STATUS_APPLICATION_APPROVED,
  STATUS_APPLICATION_STARTED,
  STATUS_APPRAISAL,
  STATUS_APPRAISAL_REQUESTED,
  STATUS_APPRAISAL_WAIVER,
  STATUS_APPROVED_NOT_ACCEPTED,
  STATUS_CLEAR_TO_CLOSE_COMPLETED,
  STATUS_CLOSED_FOR_INCOMPLETENESS,
  STATUS_CLOSING,
  STATUS_DECLINED,
  STATUS_DOCUMENTS_SIGNED,
  STATUS_EXTENDED,
  STATUS_FINAL_VERIFICATION_OF_EMPLOYMENT,
  STATUS_FUNDED,
  STATUS_FUNDING,
  STATUS_IN_PROCESSING,
  STATUS_INCOMPLETE_FOLLOWUP,
  STATUS_INVITATION_SENT,
  STATUS_LOAN_CLOSED,
  STATUS_PRE_QUALIFIED,
  STATUS_SUBMITTED,
  STATUS_UNDER_REVIEW,
  STATUS_WITHDRAW,
} from 'src/services/constants';
import {
  SMARTMATCH_TYPE_ADMIN_LOAN_OFFICER,
  SMARTMATCH_TYPE_LOAN_OFFICER,
} from 'src/services/constants';


const stageFundingApplicant = {
  children: [
    {
      stages: [
        {
          display_name: STATUS_LOAN_CLOSED,
          name: STATUS_LOAN_CLOSED,
        },
      ],
    },
  ],
  display_name: STATUS_FUNDING,
  name: STATUS_FUNDING,
};

const stageDocSignedApplicant = {
  children: [
    {
      stages: [
        {
          display_name: STATUS_FUNDING,
          name: STATUS_FUNDING,
        },
      ],
    },
  ],
  display_name: STATUS_DOCUMENTS_SIGNED,
  name: STATUS_DOCUMENTS_SIGNED,
};

const stageClearToCloseApplicant = {
  children: [
    {
      stages: [
        {
          display_name: STATUS_DOCUMENTS_SIGNED,
          name: STATUS_DOCUMENTS_SIGNED,
        },
      ],
    },
  ],
  display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
  name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
};

const stageAppraisalApplicant = {
  children: [
    {
      stages: [
        {
          display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
          name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
        },
      ],
    },
  ],
  display_name: STATUS_APPRAISAL,
  name: STATUS_APPRAISAL,
};

const stageApplicationApprovedApplicant = {
  children: [
    {
      stages: [
        {
          display_name: STATUS_APPRAISAL,
          name: STATUS_APPRAISAL,
        },
      ],
    },
  ],
  display_name: STATUS_APPLICATION_APPROVED,
  name: STATUS_APPLICATION_APPROVED,
};

const stageSubmittedApplicant = {
  children: [
    {
      stages: [
        {
          display_name: STATUS_APPLICATION_APPROVED,
          name: STATUS_APPLICATION_APPROVED,
        },
      ],
    },
  ],
  display_name: STATUS_SUBMITTED,
  name: STATUS_SUBMITTED,
};

const stageApplicationStartedApplicant = {
  children: [
    {
      stages: [
        {
          display_name: STATUS_SUBMITTED,
          name: STATUS_SUBMITTED,
        },
      ],
    },
  ],
  display_name: STATUS_APPLICATION_STARTED,
  name: STATUS_APPLICATION_STARTED,
};

// ------

const stageDocumentSignedPersonalLoansApplicant = {
  children: [
    {
      stages: [
        {
          display_name: STATUS_FUNDING,
          name: STATUS_FUNDING,
        },
        {
          display_name: STATUS_LOAN_CLOSED,
          name: STATUS_LOAN_CLOSED,
        },
      ],
    },
  ],
  display_name: STATUS_DOCUMENTS_SIGNED,
  name: STATUS_DOCUMENTS_SIGNED,
};

const stageApplicationApprovedPersonalLoanApplicant = {
  children: [
    {
      stages: [
        {
          display_name: STATUS_DOCUMENTS_SIGNED,
          name: STATUS_DOCUMENTS_SIGNED,
        },
      ],
    },
  ],
  display_name: STATUS_APPLICATION_APPROVED,
  name: STATUS_APPLICATION_APPROVED,
};

const stagePrequalifiedPersonalLoanApplicant = {
  children: [
    {
      stages: [
        {
          display_name: STATUS_APPLICATION_APPROVED,
          name: STATUS_APPLICATION_APPROVED,
        },
      ],
    },
  ],
  display_name: STATUS_PRE_QUALIFIED,
  name: STATUS_PRE_QUALIFIED,
};

const stageUnderReviewPersonalLoanApplicant = {
  children: [
    {
      stages: [
        {
          display_name: STATUS_PRE_QUALIFIED,
          name: STATUS_PRE_QUALIFIED,
        },
      ],
    },
  ],
  display_name: STATUS_UNDER_REVIEW,
  name: STATUS_UNDER_REVIEW,
};

const stageSubmittedPersonalLoanApplicant = {
  children: [
    {
      stages: [
        {
          display_name: STATUS_UNDER_REVIEW,
          name: STATUS_UNDER_REVIEW,
        },
      ],
    },
  ],
  display_name: STATUS_SUBMITTED,
  name: STATUS_SUBMITTED,
};

const stageApplicantStartedPersonalLoanApplicant = {
  children: [
    {
      stages: [
        {
          display_name: STATUS_SUBMITTED,
          name: STATUS_SUBMITTED,
        },
      ],
    },
  ],
  display_name: STATUS_APPLICATION_STARTED,
  name: STATUS_APPLICATION_STARTED,
};

const stageFundingResidentialMortgage = {
  children: [
    {
      stages: [
        {
          display_name: STATUS_LOAN_CLOSED,
          name: STATUS_LOAN_CLOSED,
        },
        {
          display_name: STATUS_INCOMPLETE_FOLLOWUP,
          name: STATUS_CLOSED_FOR_INCOMPLETENESS,
        },
      ],
    },
  ],
  display_name: STATUS_FUNDING,
  name: STATUS_FUNDING,
};
// ==

const stageDocumentsSignedResidentialMortgage = {
  children: [
    {
      stages: [
        {
          display_name: APPRAISAL_ORDERED,
          name: APPRAISAL_ORDERED,
        },
        {
          display_name: STATUS_FUNDING,
          name: STATUS_FUNDING,
        },
        {
          display_name: STATUS_DECLINED,
          name: STATUS_DECLINED,
        },
        {
          display_name: STATUS_WITHDRAW,
          name: STATUS_WITHDRAW,
        },
        {
          display_name: STATUS_INCOMPLETE_FOLLOWUP,
          name: STATUS_CLOSED_FOR_INCOMPLETENESS,
        },
        {
          display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
          name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
        },
      ],
    },
  ],
  display_name: STATUS_DOCUMENTS_SIGNED,
  name: STATUS_DOCUMENTS_SIGNED,
};


const stageClearToCloseResidentialMortgage = {
  children: [
    {
      stages: [
        {
          display_name: STATUS_CLOSING,
          name: STATUS_CLOSING,
        },
        {
          display_name: STATUS_DECLINED,
          name: STATUS_DECLINED,
        },
        {
          display_name: STATUS_WITHDRAW,
          name: STATUS_WITHDRAW,
        },
        {
          display_name: STATUS_LOAN_CLOSED,
          name: STATUS_LOAN_CLOSED,
        },
        {
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
          name: STATUS_APPROVED_NOT_ACCEPTED,
        },
        {
          display_name: STATUS_INCOMPLETE_FOLLOWUP,
          name: STATUS_CLOSED_FOR_INCOMPLETENESS,
        },
      ],
    },
  ],
  display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
  name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
};


const stageClosingResidentialMortgage = {
  children: [
    {
      stages: [
        {
          display_name: STATUS_FUNDED,
          name: STATUS_FUNDED,
        }
      ],
    },
  ],
  display_name: STATUS_CLOSING,
  name: STATUS_CLOSING,
};

const stageAppraisalAcceptedResidentialMortgage = {
  children: [
    {
      stages: [
        {
          display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
          name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
        },
        {
          display_name: STATUS_WITHDRAW,
          name: STATUS_WITHDRAW,
        },
        {
          display_name: STATUS_DECLINED,
          name: STATUS_DECLINED,
        },
        {
          display_name: STATUS_APPLICATION_APPROVED,
          name: STATUS_APPLICATION_APPROVED,
        },
        {
          display_name: STATUS_DOCUMENTS_SIGNED,
          name: STATUS_DOCUMENTS_SIGNED,
        },
        {
          display_name: STATUS_FUNDING,
          name: STATUS_FUNDING,
        },
        {
          display_name: STATUS_LOAN_CLOSED,
          name: STATUS_LOAN_CLOSED,
        },
        {
          display_name: STATUS_INCOMPLETE_FOLLOWUP,
          name: STATUS_CLOSED_FOR_INCOMPLETENESS,
        },
      ],
    },
  ],
  display_name: APPRAISAL_ACCEPTED,
  name: APPRAISAL_ACCEPTED,
};

const stageAppraisalReceivedResidentialMortgage = {
  children: [
    {
      stages: [
        {
          display_name: APPRAISAL_ACCEPTED,
          name: APPRAISAL_ACCEPTED,
        },
        {
          display_name: STATUS_WITHDRAW,
          name: STATUS_WITHDRAW,
        },
        {
          display_name: STATUS_DECLINED,
          name: STATUS_DECLINED,
        },
        {
          display_name: STATUS_APPLICATION_APPROVED,
          name: STATUS_APPLICATION_APPROVED,
        },
        {
          display_name: STATUS_DOCUMENTS_SIGNED,
          name: STATUS_DOCUMENTS_SIGNED,
        },
        {
          display_name: STATUS_FUNDING,
          name: STATUS_FUNDING,
        },
        {
          display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
          name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
        },
        {
          display_name: STATUS_LOAN_CLOSED,
          name: STATUS_LOAN_CLOSED,
        },
        {
          display_name: STATUS_WITHDRAW,
          name: STATUS_WITHDRAW,
        },
        {
          display_name: STATUS_INCOMPLETE_FOLLOWUP,
          name: STATUS_CLOSED_FOR_INCOMPLETENESS,
        },
      ],
    },
  ],
  display_name: APPRAISAL_RECEIVED,
  name: APPRAISAL_RECEIVED,
};

const stageAppraisalScheduledResidentialMortgage = {
  children: [
    {
      stages: [
        {
          display_name: APPRAISAL_RECEIVED,
          name: APPRAISAL_RECEIVED,
        },
        {
          display_name: STATUS_WITHDRAW,
          name: STATUS_WITHDRAW,
        },
        {
          display_name: STATUS_DECLINED,
          name: STATUS_DECLINED,
        },
        {
          display_name: STATUS_INCOMPLETE_FOLLOWUP,
          name: STATUS_CLOSED_FOR_INCOMPLETENESS,
        },
      ],
    },
  ],
  display_name: APPRAISAL_SCHEDULED,
  name: APPRAISAL_SCHEDULED,
};

const stageAppraisalOrderResidentialMortgage = {
  children: [
    {
      stages: [
        {
          display_name: APPRAISAL_SCHEDULED,
          name: APPRAISAL_SCHEDULED,
        },
        {
          display_name: STATUS_WITHDRAW,
          name: STATUS_WITHDRAW,
        },
        {
          display_name: STATUS_DECLINED,
          name: STATUS_DECLINED,
        },
        {
          display_name: STATUS_INCOMPLETE_FOLLOWUP,
          name: STATUS_CLOSED_FOR_INCOMPLETENESS,
        },
      ],
    },
  ],
  display_name: APPRAISAL_ORDERED,
  name: APPRAISAL_ORDERED,
};

const stageAppraisalResidentialMortgage = {
  children: [
    {
      stages: [
        {
          display_name: APPRAISAL_ORDERED,
          name: APPRAISAL_ORDERED,
        },
        {
          display_name: STATUS_WITHDRAW,
          name: STATUS_WITHDRAW,
        },
        {
          display_name: STATUS_DECLINED,
          name: STATUS_DECLINED,
        },
        {
          display_name: STATUS_INCOMPLETE_FOLLOWUP,
          name: STATUS_CLOSED_FOR_INCOMPLETENESS,
        },
      ],
    },
  ],
  display_name: STATUS_APPRAISAL,
  name: STATUS_APPRAISAL,
};

const stageApplicationApprovedResidentialMortgage = {
  children: [
    {
      stages: [
        {
          display_name: STATUS_APPRAISAL,
          name: STATUS_APPRAISAL,
        },
        {
          display_name: STATUS_WITHDRAW,
          name: STATUS_WITHDRAW,
        },
        {
          display_name: STATUS_DECLINED,
          name: STATUS_DECLINED,
        },
        {
          display_name: STATUS_INCOMPLETE_FOLLOWUP,
          name: STATUS_CLOSED_FOR_INCOMPLETENESS,
        },
        {
          display_name: STATUS_IN_PROCESSING,
          name: STATUS_IN_PROCESSING,
        },
      ],
    },
  ],
  display_name: STATUS_APPLICATION_APPROVED,
  name: STATUS_APPLICATION_APPROVED,
};



const stageApplicationProcessing = {
  children: [
    {
      stages: [
        {
          display_name: STATUS_APPRAISAL_REQUESTED,
          name: STATUS_APPRAISAL_REQUESTED,
        },
        {
          display_name: STATUS_APPRAISAL_WAIVER,
          name: STATUS_APPRAISAL_WAIVER,
        },
        {
          display_name: STATUS_DOCUMENTS_SIGNED,
          name: STATUS_DOCUMENTS_SIGNED,
        },
        {
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
          name: STATUS_APPROVED_NOT_ACCEPTED,
        },
      ],
    },
  ],
  display_name: STATUS_IN_PROCESSING,
  name: STATUS_IN_PROCESSING,
};

const stageApplicationAppraisalWaiver = {
  children: [
    {
      stages: [
        {
          display_name: STATUS_FINAL_VERIFICATION_OF_EMPLOYMENT,
          name: STATUS_FINAL_VERIFICATION_OF_EMPLOYMENT,
        },
        {
          display_name: STATUS_APPRAISAL_REQUESTED,
          name: STATUS_APPRAISAL_REQUESTED,
        },
      ],
    },
  ],
  display_name: STATUS_APPRAISAL_WAIVER,
  name: STATUS_APPRAISAL_WAIVER,
};

const stageApplicationAppraisalRequested = {
  children: [
    {
      stages: [
        {
          display_name: APPRAISAL_ACCEPTED,
          name: APPRAISAL_ACCEPTED,
        },
      ],
    },
  ],
  display_name: STATUS_APPRAISAL_REQUESTED,
  name: STATUS_APPRAISAL_REQUESTED,
};


const stageApplicationAppraisalAccepted = {
  children: [
    {
      stages: [
        {
          display_name: STATUS_FINAL_VERIFICATION_OF_EMPLOYMENT,
          name: STATUS_FINAL_VERIFICATION_OF_EMPLOYMENT,
        },
      ],
    },
  ],
  display_name: APPRAISAL_ACCEPTED,
  name: APPRAISAL_ACCEPTED,
};



const stageApplicationEmploymentVerification = {
  children: [
    {
      stages: [
        {
          display_name: STATUS_DOCUMENTS_SIGNED,
          name: STATUS_DOCUMENTS_SIGNED,
        },
      ],
    },
  ],
  display_name: STATUS_FINAL_VERIFICATION_OF_EMPLOYMENT,
  name: STATUS_FINAL_VERIFICATION_OF_EMPLOYMENT,
};


const stageAdditionalInformation = {
  children: [
    {
      stages: [
        {
          display_name: STATUS_UNDER_REVIEW,
          name: STATUS_UNDER_REVIEW,
        },
        {
          display_name: STATUS_APPLICATION_APPROVED,
          name: STATUS_APPLICATION_APPROVED,
        },
        {
          display_name: STATUS_WITHDRAW,
          name: STATUS_WITHDRAW,
        },
        {
          display_name: STATUS_DECLINED,
          name: STATUS_DECLINED,
        },
        {
          display_name: STATUS_PRE_QUALIFIED,
          name: STATUS_PRE_QUALIFIED,
        },
        {
          display_name: STATUS_EXTENDED,
          name: STATUS_EXTENDED,
        },
        {
          display_name: STATUS_SUBMITTED,
          name: STATUS_SUBMITTED,
        },
        {
          display_name: STATUS_INCOMPLETE_FOLLOWUP,
          name: STATUS_CLOSED_FOR_INCOMPLETENESS,
        },
      ],
    },
  ],
  display_name: STATUS_ADDITIONAL_INFORMATION,
  name: STATUS_ADDITIONAL_INFORMATION,
};


const stageSubmittedResidentialMortgage = {
  children: [
    {
      stages: [
        {
          display_name: STATUS_UNDER_REVIEW,
          name: STATUS_UNDER_REVIEW,
        },
        {
          display_name: STATUS_APPLICATION_APPROVED,
          name: STATUS_APPLICATION_APPROVED,
        },
        {
          display_name: STATUS_WITHDRAW,
          name: STATUS_WITHDRAW,
        },
        {
          display_name: STATUS_DECLINED,
          name: STATUS_DECLINED,
        },
        {
          display_name: STATUS_PRE_QUALIFIED,
          name: STATUS_PRE_QUALIFIED,
        },
        {
          display_name: STATUS_ADDITIONAL_INFORMATION,
          name: STATUS_ADDITIONAL_INFORMATION
        },
        {
          display_name: STATUS_EXTENDED,
          name: STATUS_EXTENDED,
        },
        {
          display_name: STATUS_INCOMPLETE_FOLLOWUP,
          name: STATUS_CLOSED_FOR_INCOMPLETENESS,
        },
      ],
    },
  ],
  display_name: STATUS_SUBMITTED,
  name: STATUS_SUBMITTED,
};

const stageExtended = {
  display_name: STATUS_EXTENDED,
  name: STATUS_EXTENDED,
  children: [
    {
      stages: [
        {
          display_name: STATUS_SUBMITTED,
          name: STATUS_SUBMITTED,
        },
        {
          display_name: STATUS_INCOMPLETE_FOLLOWUP,
          name: STATUS_CLOSED_FOR_INCOMPLETENESS,
        },
      ]
    }
  ]
}

const stagePrequalifiedResidentialMortgage = {
  children: [
    {
      stages: [
        {
          display_name: STATUS_APPLICATION_APPROVED,
          name: STATUS_APPLICATION_APPROVED,
        },
        {
          display_name: STATUS_DOCUMENTS_SIGNED,
          name: STATUS_DOCUMENTS_SIGNED,
        },
        {
          display_name: STATUS_FUNDING,
          name: STATUS_FUNDING,
        },
        {
          display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
          name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
        },
        {
          display_name: STATUS_LOAN_CLOSED,
          name: STATUS_LOAN_CLOSED,
        },
        {
          display_name: STATUS_WITHDRAW,
          name: STATUS_WITHDRAW,
        },
        {
          display_name: STATUS_DECLINED,
          name: STATUS_DECLINED,
        },
        {
          display_name: STATUS_INCOMPLETE_FOLLOWUP,
          name: STATUS_CLOSED_FOR_INCOMPLETENESS,
        },
      ],
    },
  ],
  display_name: STATUS_PRE_QUALIFIED,
  name: STATUS_PRE_QUALIFIED,
};

const stageApprovedNotAcceptedResidentialMortgage = {
  children: [
    {
      stages: [
        {
          display_name: STATUS_SUBMITTED,
          name: STATUS_SUBMITTED,
        },
        {
          display_name: STATUS_INCOMPLETE_FOLLOWUP,
          name: STATUS_CLOSED_FOR_INCOMPLETENESS,
        },
      ],
    },
  ],
  display_name: STATUS_APPROVED_NOT_ACCEPTED,
  name: STATUS_APPROVED_NOT_ACCEPTED,
};

const stageUnderReviewResidentialMortgage = {
  children: [
    {
      stages: [
        {
          display_name: STATUS_PRE_QUALIFIED,
          name: STATUS_PRE_QUALIFIED,
        },
        {
          display_name: STATUS_APPLICATION_APPROVED,
          name: STATUS_APPLICATION_APPROVED,
        },
        {
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
          name: STATUS_APPROVED_NOT_ACCEPTED,
        },
        {
          display_name: STATUS_DOCUMENTS_SIGNED,
          name: STATUS_DOCUMENTS_SIGNED,
        },
        {
          display_name: STATUS_FUNDING,
          name: STATUS_FUNDING,
        },
        {
          display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
          name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
        },
        {
          display_name: STATUS_LOAN_CLOSED,
          name: STATUS_LOAN_CLOSED,
        },
        {
          display_name: STATUS_WITHDRAW,
          name: STATUS_WITHDRAW,
        },
        {
          display_name: STATUS_DECLINED,
          name: STATUS_DECLINED,
        },
        {
          display_name: STATUS_INCOMPLETE_FOLLOWUP,
          name: STATUS_CLOSED_FOR_INCOMPLETENESS,
        },
      ],
    },
  ],
  display_name: STATUS_UNDER_REVIEW,
  name: STATUS_UNDER_REVIEW,
};

const stageApplicationStartedResidentialMortgage = {
  children: [
    {
      stages: [
        {
          display_name: STATUS_SUBMITTED,
          name: STATUS_SUBMITTED,
        },
        {
          display_name: STATUS_INVITATION_SENT,
          name: STATUS_INVITATION_SENT,
        },
        {
          display_name: STATUS_WITHDRAW,
          name: STATUS_WITHDRAW,
        },
        {
          display_name: STATUS_DECLINED,
          name: STATUS_DECLINED,
        },
        {
          display_name: STATUS_LOAN_CLOSED,
          name: STATUS_LOAN_CLOSED,
        },
        {
          display_name: STATUS_UNDER_REVIEW,
          name: STATUS_UNDER_REVIEW,
        },
        {
          display_name: STATUS_PRE_QUALIFIED,
          name: STATUS_PRE_QUALIFIED,
        },
        {
          display_name: STATUS_INCOMPLETE_FOLLOWUP,
          name: STATUS_CLOSED_FOR_INCOMPLETENESS,
        },
      ],
    },
  ],
  display_name: STATUS_APPLICATION_STARTED,
  name: STATUS_APPLICATION_STARTED,
};

export const FIRST_CBT_LOAN_STAGES_CONFIG = {
  id: '154878745215745754',
  loan_type: [RESIDENTIAL_MORTGAGE, PERSONALLOANS],
  namespace_id: FIRST_CBT_NAMESPACE_ID,
  roles: [
    SMARTMATCH_TYPE_LOAN_OFFICER,
    SMARTMATCH_TYPE_ADMIN,
    SMARTMATCH_TYPE_ADMIN_LOAN_OFFICER,
  ],
  stages: [
    stageApplicationStartedResidentialMortgage,
    stageSubmittedResidentialMortgage,
    stageAdditionalInformation,
    stageApplicationProcessing,
    stageApplicationEmploymentVerification,
    stageApplicationAppraisalWaiver,
    stageApplicationAppraisalRequested,
    stageApplicationAppraisalAccepted,
    stageExtended,
    stagePrequalifiedResidentialMortgage,
    stageUnderReviewResidentialMortgage,
    stageApprovedNotAcceptedResidentialMortgage,
    stageApplicationApprovedResidentialMortgage,
    stageAppraisalResidentialMortgage,
    stageClearToCloseResidentialMortgage,
    stageClosingResidentialMortgage,
    stageDocumentsSignedResidentialMortgage,
    stageFundingResidentialMortgage,
    stageAppraisalOrderResidentialMortgage,
    stageAppraisalScheduledResidentialMortgage,
    stageAppraisalReceivedResidentialMortgage,
    stageAppraisalAcceptedResidentialMortgage,
  ],
  sub_loan_types: [
    SECURED,
    PURCHASE,
    REFINANCE,
    CONSTRUCTION_LOAN,
    HOME_EQUITY,
    BALLOON_MATURITIES,
  ],
};

// NOTE: State order matters, this order is show on borrower side
export const FIRST_CBT_LOAN_STAGES_CONFIG_APPLICANT = {
  id: '154878745215745754',
  loan_type: [RESIDENTIAL_MORTGAGE],
  namespace_id: FIRST_CBT_NAMESPACE_ID,
  roles: [APPLICANT],
  stages: [
    stageApplicationStartedApplicant,
    stageSubmittedApplicant,
    stageApplicationApprovedApplicant,
    stageAppraisalApplicant,
    stageClearToCloseApplicant,
    stageDocSignedApplicant,
    stageFundingApplicant,
  ],
  sub_loan_types: [
    PURCHASE,
    REFINANCE,
    CONSTRUCTION_LOAN,
    HOME_EQUITY,
    BALLOON_MATURITIES,
  ],
};

// NOTE: State order matters, this order is show on borrower side
export const FIRST_CBT_LOAN_STAGES_CONFIG_PERSONALLOANS_APPLICANT = {
  id: '154878745215745754',
  loan_type: [PERSONALLOANS],
  namespace_id: FIRST_CBT_NAMESPACE_ID,
  roles: [APPLICANT],
  stages: [
    stageApplicantStartedPersonalLoanApplicant,
    stageSubmittedPersonalLoanApplicant,
    stageUnderReviewPersonalLoanApplicant,
    stagePrequalifiedPersonalLoanApplicant,
    stageApplicationApprovedPersonalLoanApplicant,
    stageDocumentSignedPersonalLoansApplicant,
    stageExtended
  ],
  sub_loan_types: [SECURED],
};

export const firstCBTLoanStages = [
  FIRST_CBT_LOAN_STAGES_CONFIG,
  FIRST_CBT_LOAN_STAGES_CONFIG_APPLICANT,
  FIRST_CBT_LOAN_STAGES_CONFIG_PERSONALLOANS_APPLICANT,
];
